document.addEventListener("DOMContentLoaded", function () {
  const collapsibles = document.querySelectorAll(".customCollapsible");

  collapsibles.forEach((collapsible) => {
    collapsible.addEventListener("click", function () {
      collapsibles.forEach((otherCollapsible) => {
        if (otherCollapsible !== this) {
          otherCollapsible.classList.remove("active");
          const otherContent = otherCollapsible.nextElementSibling;
          otherContent.style.maxHeight = null;
          otherContent.classList.remove("open");
        }
      });

      this.classList.toggle("active");
      const content = this.nextElementSibling;

      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        content.classList.remove("open");
      } else {
        content.style.maxHeight = content.scrollHeight + 30 + "px";
        content.classList.add("open");
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const description = document.querySelector(
    ".product__description.rte.quick-add-hidden"
  );

  if (!description) return; // Guard clause if element doesn't exist

  // Add transition for smooth animation
  description.style.transition = "max-height 0.3s ease-out";
  description.style.maxHeight = "80px";
  description.style.overflow = "hidden";

  const readMoreLink = document.createElement("a");
  readMoreLink.href = "#";
  readMoreLink.textContent = "...more";
  readMoreLink.classList.add("productDescReadMore");
  readMoreLink.style.cursor = "pointer";
  readMoreLink.style.display = "inline-block";
  readMoreLink.style.marginTop = "8px";

  description.insertAdjacentElement("afterend", readMoreLink);

  let isExpanded = false;
  readMoreLink.addEventListener("click", function (e) {
    e.preventDefault();
    isExpanded = !isExpanded;

    if (isExpanded) {
      description.style.maxHeight = description.scrollHeight + "px";
      readMoreLink.textContent = "Less";
    } else {
      description.style.maxHeight = "80px";
      readMoreLink.textContent = "...more";
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const variantSelects = document.querySelector("variant-selects");
  const quantity = document.querySelector(".product-form__quantity");

  if (variantSelects && quantity) {
    const newContainer = document.createElement("div");
    newContainer.classList.add("newContainer");
    newContainer.appendChild(variantSelects);
    newContainer.appendChild(quantity);

    const collapsibleContainer = document.querySelector(
      ".collapsibleContainer"
    );

    if (collapsibleContainer) {
      collapsibleContainer.parentNode.insertBefore(
        newContainer,
        collapsibleContainer.nextSibling
      );
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Target ALL select elements, not just the first one
  const selectElements = document.querySelectorAll(".select__select");

  selectElements.forEach(function (selectElement) {
    if (selectElement) {
      const optionLabel = selectElement
        .closest(".product-form__input--dropdown")
        .querySelector(".form__label");
      const optionName = optionLabel
        ? optionLabel.textContent.trim()
        : "option";

      // Check if placeholder already exists to avoid duplicates
      const existingPlaceholder =
        selectElement.querySelector('option[value=""]');
      if (!existingPlaceholder) {
        const placeholderOption = document.createElement("option");
        placeholderOption.textContent = `Choose ${optionName}`;
        placeholderOption.value = "";
        placeholderOption.disabled = true;
        placeholderOption.selected = true;

        selectElement.insertBefore(placeholderOption, selectElement.firstChild);
      }
    }
  });
});
